<script lang="ts">
	import { browser } from '$app/environment';
	import { goto } from '$app/navigation';

	if (browser) {
		goto('/app/enrich');
	}
</script>

<img class="illustration center" src="/images/illustrations/you-are-lost.svg" />
<div class="center">
	<p class="error-title error-message">Houston, we have a problem.</p>
	<p class="error-message">
		It seems like something is broken.
		<br />
		<b>Please refresh the page</b>, this should fix the problem.
	</p>
	<p class="error-message">
		If not, don't worry. Reach out to our support team and we will help you!
	</p>
</div>

<style>
	.center {
		display: block;
		margin-left: auto;
		margin-right: auto;
		text-align: center;
	}
	.illustration {
		width: 21%;
	}
	@media (max-width: 1280px) {
		.illustration {
			width: auto;
		}
	}
	.error-message {
		font-family: 'Inter';
		font-weight: 500;
		font-size: 24px;
		line-height: 29px;
		text-align: center;
		margin-bottom: 1rem;
	}
	.error-title {
		font-size: 34px;
	}
</style>
